import { useMemo } from "react";

import { some } from "lodash/fp";
import { useLocation } from "react-router-dom";

import {
  ProgressItemEnum,
  ProgressItemState,
} from "@app/analytics/GettingStarted/types";
import { isProgressItemCompleted } from "@app/analytics/GettingStarted/utils";
import { SAMPLE_MEETING_IDS } from "@app/analytics/sampleData/sampleMeetings";
import ROUTES from "@app/common/routes";

const useGetMeetingReportState = (progress: number): ProgressItemState => {
  const location = useLocation();
  const isCompleted = isProgressItemCompleted(
    progress,
    ProgressItemEnum.MEETING_REPORT
  );

  const hasViewedMeetingReport = useMemo(() => {
    if (isCompleted) return true;

    return (
      location.pathname.startsWith(ROUTES.MEETING_REPORT_ROOT) &&
      !some(
        (reportId) => location.pathname.includes(reportId),
        SAMPLE_MEETING_IDS
      )
    );
  }, [isCompleted, location.pathname]);

  const isUnmarkedComplete = hasViewedMeetingReport && !isCompleted;

  const state = isUnmarkedComplete
    ? "unmarked_complete"
    : isCompleted
      ? "complete"
      : "todo";

  return useMemo(
    () => ({
      type: ProgressItemEnum.MEETING_REPORT,
      state,
    }),
    [state]
  );
};

export default useGetMeetingReportState;
